import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { DefinitionService } from "../../services/DefinitionService";
import { mdlHotelRoomNamesRequest } from "../../models/service-models/hotel/HotelRoomNamesRequest";
import { useEffect } from "react";
import _ from "lodash";
import { mdlStopFreeSaleDetail } from "../../models/domain/StopFreeSaleDetail";

export type HotelRoomNameSelectProps = {
    typeId?: string;
    hotelId?: string;
    onChange?: Function;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
    sendObject?: boolean;
    disabled?:boolean;
    defaultValue?: string | string[];
    detail?: mdlStopFreeSaleDetail[];
}


export const HotelRoomNameSelect = (props: HotelRoomNameSelectProps) => {
    const { t } = useTranslation();


    const { data, isLoading, refetch, isError } = useQuery(
        ["getHotelRoomNames", props.hotelId, props.typeId],
        () => {
            if (props.hotelId) {
                let typeId = props.typeId;
                if(typeof props.typeId === "object"){
                    typeId = _.first((props.typeId as any)) 
                }
                var request: mdlHotelRoomNamesRequest = { typeId: typeId, hotelId: props.hotelId };
                return DefinitionService.HotelRoomNames(request);
            }
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!props.hotelId,
            onSuccess: (response) => {
                if (props.detail && response?.body?.data) {
                    const foundRoom = response.body.data.find(room => room.name === props.detail?.[0]?.roomName);
                    if (foundRoom && props.onChange) {
                        props.onChange(props.sendObject ? foundRoom : foundRoom.id);
                    }
                }
            }
        }
    );

    const handleSendObject = (option: any) => {
        const selectedOption = Array.isArray(option) ? option.map(opt => opt) : option;
        props.onChange!(selectedOption);
    }

    let cities = [...[{ "id": "00000000-0000-0000-0000-000000000000","name": t('common.all'),"attr2": 0 }],...data?.body?.data ?? []];
    

    return (
        <>
            <Select
                mode={props.mode}
                loading={isLoading}
                size="middle"
                disabled={props.disabled}
                defaultValue={props.mode == "multiple" ? props.defaultValue as string[] : props.defaultValue as string}
                value={props.mode == "multiple" ? props.value as string[] : props.value as string}
                onChange={(value: string | string[], option: any) =>
                    props.sendObject ? handleSendObject(option) : props.onChange!(value)}
                showSearch
                placeholder={t("common.chooseHotelRoomName")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={cities?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id
                }))}
            />
        </>
    )
}